import { render, staticRenderFns } from "./mailconfig.vue?vue&type=template&id=4e9290ac"
import script from "./mailconfig.vue?vue&type=script&lang=js"
export * from "./mailconfig.vue?vue&type=script&lang=js"
import style0 from "./mailconfig.vue?vue&type=style&index=0&id=4e9290ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports